export default {
  title: {
    jobPostingChannelAccountManagement: 'Job Board Account Management',
    jobPostingChannelAccountAdd: 'Add',
    jobPostingChannelAccountEdit: 'Edit'
  },
  menu: 'Job Board Account Management',
  label: {
    channelName: 'Job board',
    job51MemberName: 'Member name',
    username: 'Username',
    password: 'Password',
    status: 'Status',
    authorizedUser: 'Assign to',
    isPublic: 'Is Public',
    job51: '51job.com',
    zhiLian: 'Zhaopin.com',
    liepin: 'Liepin.com',
    boss: 'Zhipin.com (BOSS)',
    lietou: 'Liepin agency',
    authorizeAll: 'All',
    customAuthorization: 'Custom',
    all: 'All'
  },
  btn: {
    addAccount: 'Add'
  },
  message: {
    deleteDialogTitle: 'Please confirm to delete the account, {username} for {channel}.',
    deleteSuccess: 'Successfully deleted',
    noChannelAccount: 'Oops, seems there is no account been connected to this job board. Please add an account in Job Board Account Management under Company Admin tab. Check with your AJINGA client success manager for further help.'
  },
  placeholder: {
    channelName: 'Please select channel',
    job51MemberName: 'Please input member name',
    username: 'Please input username',
    password: 'Please input password',
    authorizedUser: 'Please select user'
  }
}
